import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import Link from 'next/link';
import * as S from './styles';

const msgs = defineMessages({
  title: {
    id: 'core_loop_tab_names_video',
    defaultMessage: 'Videos',
  },
  description: {
    id: 'onboarding_welcome_bulletpoint_2',
    defaultMessage: 'Immerse in locals speaking videos',
  },
});

export const ImmerseCard: FC = () => {
  const intl = useIntl();

  return (
    <Link href={ROUTES.video.immerse} passHref legacyBehavior>
      <S.CardContainer>
        <S.IconContainer>
          <Icon name="videoLibraryFilled" />
        </S.IconContainer>
        <S.Content>
          <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
          <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
        </S.Content>
      </S.CardContainer>
    </Link>
  );
};
